function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import TextInput from '../text';
import { pickValidValues } from '../../../helpers/components-helpers'; // Copied from myhippo-dotcom deepEmail

export var CORE_EMAIL_REGEX = '(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))';
export var makeEmailRegex = allowTrimmableSpaces => {
  var innerRegex = allowTrimmableSpaces ? "[ ]*".concat(CORE_EMAIL_REGEX, "[ ]*") : CORE_EMAIL_REGEX;
  return "^".concat(innerRegex, "$");
};

class EmailInput extends Component {
  _modifyWithDefaultOptions() {
    var _this$props = this.props,
        {
      allowTrimmableSpaces,
      options
    } = _this$props,
        rest = _objectWithoutProperties(_this$props, ["allowTrimmableSpaces", "options"]);

    var optionsWithValidValue = pickValidValues(options);
    var emailRegex = makeEmailRegex(!!allowTrimmableSpaces);
    return _objectSpread(_objectSpread({
      autoComplete: 'email'
    }, rest), {}, {
      options: Object.assign({
        pattern: emailRegex
      }, optionsWithValidValue)
    });
  }

  render() {
    var modifiedProps = this._modifyWithDefaultOptions();

    return /*#__PURE__*/React.createElement(TextInput, modifiedProps);
  }

}

_defineProperty(EmailInput, "defaultProps", {
  options: {}
});

export default EmailInput;